module.exports = __webpack_public_path__ + "static/media/25487186_1703515649723619_6219381313886810684_o.3b02f671.jpg";